module.exports = __webpack_public_path__ + "static/media/github.c9a0f2e4.svg";